'use client';

import { useCallback, useEffect } from 'react';
import { useToast } from '@/utils/providers/ToastProvider';

export default function Error({ error }: { error: Error & { digest?: string } }): null {
	const { showToast } = useToast();

	const handleShowToast = useCallback(() => {
		showToast({
			message: error.message,
			severity: 'error',
		});
	}, [error.message, showToast]);

	useEffect(() => {
		handleShowToast();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error]);

	return null;
}
